import React, { useEffect, useState } from "react";
import DashboardLayout from "../DashboardLayout";
import TagsList from "./TagList";
import { useAppContext } from "../../services/context";
import { handleErrors } from "../../services/dataManager";
import { useNavigate } from "react-router-dom";
import { getPaginatedGameTags } from "../../services/axios/apiManager";

const GameTags = () => {
  const navigate = useNavigate();
  const { state } = useAppContext();
  const { permissions } = state;
  const [tags, setTags] = useState([]);
  const [pagination, setPagination] = useState({});
  const [granted, setGranted] = useState([]);

  const extractPermissions = () => {
    const perms = permissions.filter((f) => f.module === "Tags");
    if (perms) {
      setGranted(perms);
    }
  };
  const getData = async () => {
    const res = await getPaginatedGameTags();
    if (res?.data?.success && res?.data?.data) {
      setTags(res.data.data);
      if (res?.data?.pagination) {
        setPagination(res.data.pagination);
      }
    } else handleErrors(res, navigate, "Tags List:");
  };
  useEffect(() => {
    extractPermissions();
    getData();
  }, []);
  return (
    <DashboardLayout>
      <div
        style={{ overflowY: "hidden" }}
        className="overflow-hidden"
        data-testid="tags"
      >
        <div className="col-12 mb-3">
          <div className="page-title-box d-sm-flex">
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <a>System Settings</a>
                </li>
                <li
                  className="breadcrumb-item active"
                  style={{ color: "#8b8b8cbf" }}
                >
                  Tags
                </li>
              </ol>
            </div>
          </div>
        </div>

        <TagsList
          tags={tags}
          setTags={setTags}
          pagination={pagination}
          setPagination={setPagination}
          granted={granted}
        />
      </div>
    </DashboardLayout>
  );
};

export default GameTags;
